import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { CookieService } from 'app/services/cookie.service';
import { ObservableRequestService } from 'app/services/observable-request.service';

import { OrganisationDetails } from 'app/shared/models/org-details.model';

@Injectable()
/**
 * Service class to provide methods for generic search on header.
 */
export class GenericSearchService {
    // As our URL is accessed through IFrame which is an external content for
    // angular application. So, we need to bypass security trust check using
    // DOM Sanitizer in order to display content for our URL.
    constructor(
        private observableRequest: ObservableRequestService,
        private domSanitizer: DomSanitizer,
        private cookieService: CookieService,
        private http: Http
    ) { }

    // Method to fetch search results.
    getHeaderSearchResults(
        searchQuery: string, searchURI: string): Observable<any> {
        const headerSearchUri = searchURI + '/' + searchQuery;
        return this.observableRequest.getRequest(headerSearchUri);
    }

    getOrganisationDetails(orgId: number): Observable<any> {
        const orgDetailsURI = ConstantsService.ORGANISATION_DETAILS + '/' + orgId;
        return this.observableRequest.getRequest(orgDetailsURI)
            .map(response => {
                return plainToClass(OrganisationDetails, response.arrResult as Object[]);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/genericsearch/generic-search.service.ts